import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Tab, Tabs } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import Backend from '../../Backend';
import Connection from '../../Calls';
import NavbarComponent from '../Navbar/index';
import ExchangeComponent from './Exchange/ExchangeComponent';
import WalletIndex from './Wallets/WalletsComponent';
import ModalWallets from '../Modal/ModalWallet';
import TransactionComponent from './Transactions/TransactionsComponent';

import list_coins from './ListCoins';

import lang_en from "../../translate/en"
import lang_es from "../../translate/es"

import './index.css';

const VirtualExchangeIndex = (props) => {
  const [wallets, setWallets] = useState([]);
  const [coins, setCoins] = useState([]);
  const [planInfo, setPlanInfo] = useState([]);
  const [coinsInfo, setCoinsInfo] = useState([]);
  const [cryptoStatus, setCryptoStatus] = useState(false);
  const [contractStatus, setContractStatus] = useState('pending');
  const [prices, setPrices] = useState({});
  const [balance, setBalance] = useState({
    balance_virtual: 0,
    balance_virtual_mxn: 0
  })

  useEffect(()=> {
    getWallets();
    getCoinsForWallets();
    getGroupPlanInfo();
    getBalanceVirtual();
    getCryptoBuyInfo();
  }, [])

  useEffect(()=> {
  }, [balance,wallets])

  useEffect(() => {
    const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const wsHost = window.location.hostname === "localhost" ? "50.116.20.64:8765" : window.location.host + "/ws/prices";
    const ws = new WebSocket(wsProtocol + "//" + wsHost);
    ws.onopen = () => {
      ws.send("GNTWIREBIT");
    }
    ws.onmessage = (e) => {
      const message = JSON.parse(e.data);
      setPrices(message);
    }
    return () => {
      ws.close()
    }
  }, []);

  const getCryptoBuyInfo = () => {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.getCryptoBuyInfo(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, async response => {
        if(response.status.code === '0'){
          const {contract_status, crypto_buy_status} = await response.payload;
          setCryptoStatus(crypto_buy_status)
          setContractStatus(contract_status);
        } else {
          setCryptoStatus(false)
          setContractStatus('pending');
        }
      })
    })
  }

  const getWallets = () => {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GetWallets(localStorage.getItem('email'), localStorage.getItem('token'), '', '1', '9999', response.payload.r01, response => {
        if(response.status.code === '0'){
          setWallets(response.payload)
        }
      })
    })
  }

  const getBalanceVirtual = () => {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.BalanceVirtualExchange(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          setBalance({
            balance_virtual: response.payload[0].balance,
            balance_virtual_mxn: response.payload[1].balance
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
  }

  const getCoinsForWallets = () => {
    let lang = localStorage.getItem("lan")
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.AvailablePairs(response.payload.r01, response => {
        if (response.status.code == 0 ) {
          let coin_object = {}
          response.payload.forEach((item, i) => {
              var coin = item.pair.split("/");
              coin = coin[0].toLowerCase();
              coin_object[coin] = {symbol: coin, name: list_coins[coin],  decimal: item.decimals, type:'crypto'}
          });
          let list_available_coins = Object.keys(coin_object).map(coin => {
            return(coin_object[coin])
          })
          list_available_coins.push({symbol:'vmxn',name: 'Virtual MXN', decimal: 2, type:'vmxn', })
          setCoins([...list_available_coins])
          //setCoins([{coin: "tdc", symbol:'tdc',name: lang=== 'es' ? lang_es.VEX.tdc : lang_en.VEX.tdc}, ...list_available_coins])
        }
      })
    })
  }

  const getGroupPlanInfo = () => {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GroupInformationPlanInfo(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          const {plan, coins} = response.payload;
          setPlanInfo(plan)
          setCoinsInfo(coins)
        }
      })
    })
  }

  const handleWalletCreated = (response) => {
    getWallets();
  }
  const handleVexOrderCreated = (response) => {
    getWallets();
    getBalanceVirtual();
    getGroupPlanInfo();
  }

  return(
    <>
      <NavbarComponent data={props} selected="virtualexchange" logged={true}/>
      <ModalWallets
        {...props}
        title="Add Wallet"
        coins={coins}
        wallets={wallets}
        coinsInfo={coinsInfo}
        planInfo={planInfo}
      />
      <div className="contenedor-wallets-generals" style={{overflowX: 'hidden'}}>
        <Row className="responsive-row-wrapper">
          <Col xl={6} lg={6}>
            <ExchangeComponent
              {...props}
              wallets={wallets}
              coins={coins}
              planInfo={planInfo}
              coinsInfo={coinsInfo}
              prices={prices}
              balance={balance}
              getWallets={getWallets}
              getBalanceVirtual={getBalanceVirtual}
              handleVexOrderCreated={handleVexOrderCreated}
              handleWalletCreated={handleWalletCreated}
              cryptoStatus={cryptoStatus}
              contractStatus={contractStatus}
            />
          </Col>
          <Col xl={6} lg={6}>
            <Tabs
              defaultActiveKey="wallet"
              id="tab-vex"
            >
              <Tab eventKey="wallet" title={props.traductions.VEX.wallet} tabClassName='color'>
                <WalletIndex {...props} balance={balance} coins={coins} planInfo={planInfo} coinsInfo={coinsInfo} prices={prices} wallets={wallets}/>
              </Tab>
              <Tab eventKey="transaction" title={props.traductions.VEX.titleT}>
                <TransactionComponent {...props}/>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default VirtualExchangeIndex
